import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { RolesFilterOption } from '../../models/role-filter-option';
import { RoleRegister } from '../../role-register';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-role-register',
    templateUrl: './system-role-register.component.html',
    standalone: false
})
export class SystemRoleRegisterComponent extends RoleRegister {
   constructor(public store: Store) {
      super(store);
      const filters: RolesFilterOption[] = [
         {
            field: 'AccountId',
            operation: FilterOperations.HasValue,
            type: 'numeric',
            value: false,
         },
      ];
      this.filters = filters;
      this.columns = ['name', 'description', 'roleUserCount', 'systemRoleActionsMenu'];
   }
}
